import React from 'react';
import { useSelector } from 'react-redux';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Fi from 'react-icons/fi';
import cn from 'classnames';

const TableImport = ({ data, onDelete, onUpdate }) => {
  const StateForm = useSelector((state) => state?.Form);

  return (
    <div>
      <div className="bg-white py-md-3 px-3 border rounded-2">
        <div className="row">
          <div className="col-12">
            <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
              Daftar Customer
            </div>

            <div className="table-responsive bg-white">
              <table
                width="100%"
                className="table table-hover table-vcenter card-table datatable border"
              >
                <thead className="bg-light">
                  <tr className="th">
                    <td>No</td>
                    <td
                      style={{
                        whiteSpace: 'pre-wrap',
                        width: '10%',
                        textAlign: 'left',
                      }}
                    >
                      Entities
                    </td>
                    <td
                      style={{
                        whiteSpace: 'pre-wrap',
                        width: '10%',
                        textAlign: 'left',
                      }}
                    >
                      Nama
                    </td>
                    <td
                      style={{
                        whiteSpace: 'pre-wrap',
                        width: '15%',
                        textAlign: 'left',
                      }}
                    >
                      Nama Perusahaan
                    </td>
                    <td
                      style={{
                        whiteSpace: 'pre-wrap',
                        width: '20%',
                        textAlign: 'left',
                      }}
                    >
                      Alamat
                    </td>
                    <td
                      style={{
                        whiteSpace: 'pre-wrap',
                        width: '15%',
                        textAlign: 'left',
                      }}
                    >
                      PIC
                    </td>
                    <td
                      style={{
                        whiteSpace: 'pre-wrap',
                        width: '15%',
                        textAlign: 'left',
                      }}
                    >
                      Finance
                    </td>
                    <td></td>
                  </tr>
                </thead>

                <tbody>
                  {data?.map((d, i) => (
                    <tr
                      key={i}
                      className={cn(
                        StateForm?.errors[`datas.${i}.entities`] ||
                          StateForm?.errors[`datas.${i}.name`] ||
                          StateForm?.errors[`datas.${i}.company_name`] ||
                          StateForm?.errors[`datas.${i}.address`] ||
                          StateForm?.errors[`datas.${i}.pic_name`] ||
                          StateForm?.errors[`datas.${i}.pic_email`] ||
                          StateForm?.errors[`datas.${i}.pic_phone`] ||
                          StateForm?.errors[`datas.${i}.finance_name`] ||
                          StateForm?.errors[`datas.${i}.finance_emails`] ||
                          StateForm?.errors[`datas.${i}.finance_phone`]
                          ? 'border-danger border-bottom'
                          : null
                      )}
                    >
                      <td>
                        <div className="text-left fs-8 text-uppercase fw-semibold">
                          {i + 1}
                        </div>
                      </td>
                      <td style={{ whiteSpace: 'pre-wrap', width: '10%' }}>
                        <div className="text-left fs-8 text-uppercase fw-semibold">
                          {d?.entities}
                        </div>

                        {StateForm?.errors[`datas.${i}.entities`] ? (
                          <div className="invalid-feedback d-block ">
                            {StateForm?.errors[`datas.${i}.entities`]}
                          </div>
                        ) : null}
                      </td>
                      <td style={{ whiteSpace: 'pre-wrap', width: '10%' }}>
                        <div className="text-left fs-8 text-uppercase fw-semibold">
                          {d?.name}
                        </div>

                        {StateForm?.errors[`datas.${i}.name`] ? (
                          <div className="invalid-feedback d-block ">
                            {StateForm?.errors[`datas.${i}.name`]}
                          </div>
                        ) : null}
                      </td>
                      <td style={{ whiteSpace: 'nowrap', width: '15%' }}>
                        <div className="text-left fs-8 text-uppercase fw-semibold">
                          {d?.company_name}
                        </div>
                        {StateForm?.errors[`datas.${i}.company_name`] ? (
                          <div className="invalid-feedback d-block ">
                            {StateForm?.errors[`datas.${i}.company_name`]}
                          </div>
                        ) : null}
                      </td>
                      <td style={{ whiteSpace: 'pre-wrap', width: '30%' }}>
                        <div className="text-left fs-8 text-uppercase fw-semibold">
                          {d?.address}
                        </div>
                        {StateForm?.errors[`datas.${i}.address`] ? (
                          <div className="invalid-feedback d-block ">
                            {StateForm?.errors[`datas.${i}.address`]}
                          </div>
                        ) : null}
                      </td>
                      <td style={{ whiteSpace: 'pre-wrap', width: '15%' }}>
                        <div className="text-left fs-8 text-uppercase fw-semibold">
                          {d?.pic_name}
                        </div>
                        {StateForm?.errors[`datas.${i}.pic_name`] ? (
                          <div className="invalid-feedback d-block ">
                            {StateForm?.errors[`datas.${i}.pic_name`]}
                          </div>
                        ) : null}

                        <div className="text-left fs-9 text-lowercase">
                          {d?.pic_email}
                        </div>
                        {StateForm?.errors[`datas.${i}.pic_email`] ? (
                          <div className="invalid-feedback d-block ">
                            {StateForm?.errors[`datas.${i}.pic_email`]}
                          </div>
                        ) : null}

                        <div className="text-left fs-9 text-lowercase">
                          {d?.pic_phone}
                        </div>
                        {StateForm?.errors[`datas.${i}.pic_phone`] ? (
                          <div className="invalid-feedback d-block ">
                            {StateForm?.errors[`datas.${i}.pic_phone`]}
                          </div>
                        ) : null}
                      </td>
                      <td style={{ whiteSpace: 'nowrap', width: '15%' }}>
                        <div className="text-left fs-8 text-uppercase fw-semibold">
                          {d?.finance_name}
                        </div>
                        {StateForm?.errors[`datas.${i}.finance_name`] ? (
                          <div className="invalid-feedback d-block ">
                            {StateForm?.errors[`datas.${i}.finance_name`]}
                          </div>
                        ) : null}

                        <div className="text-left fs-9 text-lowercase">
                          {d?.finance_emails ? d?.finance_emails?.join(', '): '-'}
                        </div>
                        {StateForm?.errors[`datas.${i}.finance_emails`] ? (
                          <div className="invalid-feedback d-block ">
                            {StateForm?.errors[`datas.${i}.finance_emails`]}
                          </div>
                        ) : null}

                        <div className="text-left fs-9 text-lowercase">
                          {d?.finance_phone}
                        </div>
                        {StateForm?.errors[`datas.${i}.finance_phone`] ? (
                          <div className="invalid-feedback d-block ">
                            {StateForm?.errors[`datas.${i}.finance_phone`]}
                          </div>
                        ) : null}
                      </td>

                      <td className="text-end">
                        <div
                          className="btn-toolbar justify-content-end"
                          role="toolbar"
                        >
                          <div className="btn-group" role="group">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id={`tooltip-top`}>Perbaharui</Tooltip>
                              }
                            >
                              <button
                                type="button"
                                onClick={() => onUpdate(d, i)}
                                className="btn btn-ghost-primary px-2"
                              >
                                <Fi.FiEdit size={17} />
                              </button>
                            </OverlayTrigger>

                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id={`tooltip-top`}>Hapus</Tooltip>
                              }
                            >
                              <button
                                type="button"
                                onClick={() => onDelete(i)}
                                className="btn btn-ghost-danger px-2"
                              >
                                <Fi.FiTrash2 size={17} />
                              </button>
                            </OverlayTrigger>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableImport;
